import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "sales";

const initialState = {
  loading: null,
  salesNo: 0,
  salesMasterList: [],
  salesDetailsList: [],
  salesResponse: {},
  errorMessage: "",
};

//GET
export const getSalesNoFromServer = createAsyncThunk(
  `${namespace}/getSalesNoFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/salesno", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getOpeningBalanceFromCustomerMaster = createAsyncThunk(
  `${namespace}/getOpeningBalanceFromCustomerMaster`,
  async (existingCustomer, { rejectWithValue }) => {
    try {
      const id = parseInt(existingCustomer.Id);
      const response = await api.get(`/openingbalancefromcustomers?id=${id}`, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//POST
export const addSalesDetailsToServer = createAsyncThunk(
  `${namespace}/addSalesDetailsToServer`,
  async (salesDetails, { rejectWithValue }) => {
    try {
      const response = await api.post("/sales", salesDetails, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getSalesMasterInfoFromServer = createAsyncThunk(
  `${namespace}/getSalesMasterInfoFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/salesmasters", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getSalesDetailsInfoFromServer = createAsyncThunk(
  `${namespace}/getSalesDetailsInfoFromServer`,
  async (existingSales, { rejectWithValue }) => {
    const salesno = parseInt(existingSales?.SalesNo);
    try {
      const response = await api.get(`/salesdetails?salesNo=${salesno}`, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//PATCH
export const updateSalesDetailsToServer = createAsyncThunk(
  `${namespace}/updateSalesDetailsToServer`,
  async (updatedSalesDetails, { rejectWithValue }) => {
    try {
      const salesno = parseInt(updatedSalesDetails.salesNo);
      const response = await api.patch(
        `/updatesales/${salesno}`,
        updatedSalesDetails,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//DELETE
export const deleteSalesDetailFromServer = createAsyncThunk(
  `${namespace}/deleteSalesDetailFromServer`,
  async (existingSales, { rejectWithValue }) => {
    try {
      const salesno = existingSales.SalesNo;
      const customerCode = existingSales.customercode;
      const openingBalance = existingSales.OpeningBalance;
      const loginUser = existingSales.loginUser;

      const response = await api.patch(
        `/deletesalesdetail/${salesno}`,
        {
          params: { loginUser, customerCode, openingBalance },
        },
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getSalesDetailsforPrintfromServer = createAsyncThunk(
  `${namespace}/getSalesDetailsforPrintfromServer`,
  async (existingSales, { rejectWithValue }) => {
    const salesno = parseInt(existingSales?.SalesNo);
    try {
      const response = await api.get(`/printsalesdetails?salesNo=${salesno}`, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getSalesMasterCountFromServer = createAsyncThunk(
  `${namespace}/getSalesMasterCountFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/salesmasterCount", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getSalesMasterFromServerByPagination = createAsyncThunk(
  `${namespace}/getSalesMasterFromServerByPagination`,
  async ({ pageNo, rowSize }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/salesmasterpagination?pageNo=${pageNo}&rowSize=${rowSize}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const salesSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSalesNoFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getSalesNoFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.salesNo = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getSalesNoFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.salesNo = 0;
        state.errorMessage = error.errorMessage;
      })
      .addCase(getOpeningBalanceFromCustomerMaster.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(
        getOpeningBalanceFromCustomerMaster.fulfilled,
        (state, action) => {
          state.loading = HTTP_STATUS.FULFILLED;
          state.errorMessage = null;
        }
      )
      .addCase(
        getOpeningBalanceFromCustomerMaster.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.errorMessage = error.errorMessage;
        }
      )
      .addCase(addSalesDetailsToServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(addSalesDetailsToServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.salesResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(addSalesDetailsToServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage;
      })
      .addCase(getSalesMasterInfoFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getSalesMasterInfoFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.salesMasterList = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getSalesMasterInfoFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.salesMasterList = [];
        state.errorMessage = error.errorMessage;
      })
      .addCase(getSalesDetailsInfoFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getSalesDetailsInfoFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.salesDetailsList = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getSalesDetailsInfoFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.salesDetailsList = [];
        state.errorMessage = error.errorMessage;
      })
      .addCase(updateSalesDetailsToServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(updateSalesDetailsToServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.salesResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(updateSalesDetailsToServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.salesResponse = {};
        state.errorMessage = error.errorMessage;
      })
      .addCase(deleteSalesDetailFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(deleteSalesDetailFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(deleteSalesDetailFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage;
      })
      .addCase(getSalesMasterCountFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getSalesMasterCountFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(getSalesMasterCountFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage1;
      })
      .addCase(getSalesMasterFromServerByPagination.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(
        getSalesMasterFromServerByPagination.fulfilled,
        (state, action) => {
          state.loading = HTTP_STATUS.FULFILLED;
          state.errorMessage = null;
        }
      )
      .addCase(
        getSalesMasterFromServerByPagination.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.salesMasterList = [];
          state.errorMessage = error.message;
        }
      );
  },
});

export const selectSalesNo = (state) => state.sales.salesNo;
export const selectAllSalesMasters = (state) => state.sales.salesMasterList;
export const selectAllSalesDetails = (state) => state.sales.salesDetailsList;
export const selectLoadingStatus = (state) => state.sales.loading;
export default salesSlice.reducer;
